import { ccEntrySyncManualCcState } from '../../components/credit-card-entry.js';
import { opCfg, opIsMemberSession, opMemberUserId, formatPaymentDate } from './config.js';
import {
    opModal,
    openPaymentSelectedUserId,
    openPaymentHasMemberSelected,
    openPaymentCardChoiceValue,
    openPaymentIsOnline,
} from './dom.js';
import { getOpenPaymentDafCardType, setOpenPaymentDafCardType } from './daf-card-type.js';
import {
    savedPaymentsState,
    setOpenPaymentSavedCards,
    clearOpenPaymentSavedCards,
    fetchOpenPaymentSavedPayments,
    seedOpenPaymentSavedPaymentsFromConfig as seedSavedPaymentsFromConfig,
} from './saved-cards.js';
import { runAfterCloseAction, resolveOpenCreditAfterClose } from './nav.js';

export function showOpenPaymentAjaxMsg(level, html) {
    const $box = opModal().find('#ajaxMsgOpenPayment');
    $box.removeClass('alert-danger alert-success alert-warning d-none').addClass(level);
    opModal().find('#ajaxMsgOpenPaymentUl').html(html);
}

export function hideOpenPaymentAjaxMsg() {
    opModal().find('#ajaxMsgOpenPayment').addClass('d-none');
}

function openPaymentCardChoicePills() {
    return opModal().find('#open_payment_card_choice_saved, #open_payment_card_choice_new');
}

export function openPaymentSetCardChoicePillDisabled($pill, disabled, disabledTitle) {
    $pill.prop('disabled', disabled).toggleClass('is-disabled', disabled);
    if (disabled) {
        $pill.attr('aria-disabled', 'true');
        if (disabledTitle) {
            $pill.attr('title', disabledTitle);
        } else {
            $pill.removeAttr('title');
        }
        return;
    }
    $pill.removeAttr('aria-disabled');
    $pill.removeAttr('title');
}

export function openPaymentSyncCardChoicePillActive(which) {
    const p = '#open_payment_';
    openPaymentCardChoicePills()
        .removeClass('is-active')
        .attr('aria-pressed', 'false');
    if (which === 'saved') {
        opModal().find(p + 'card_choice_saved').addClass('is-active').attr('aria-pressed', 'true');
    } else if (which === 'new') {
        opModal().find(p + 'card_choice_new').addClass('is-active').attr('aria-pressed', 'true');
    }
}

export function openPaymentSyncMethodPills() {
    if (opIsMemberSession()) {
        return;
    }
    const online = openPaymentIsOnline();
    opModal().find('[data-open-payment-method-pill]').each(function () {
        const $pill = $(this);
        const val = String($pill.data('open-payment-method-pill') || '');
        const active = online ? val === 'online' : val === 'check_cash';
        $pill.toggleClass('is-active', active).attr('aria-pressed', active ? 'true' : 'false');
    });
}

export function syncOpenPaymentCardChoicePills() {
    const hasMember = openPaymentHasMemberSelected();
    const p = '#open_payment_';
    const $saved = opModal().find(p + 'card_choice_saved');
    const $new = opModal().find(p + 'card_choice_new');

    if (!hasMember) {
        const pickMemberTitle = 'Select a member to continue';
        openPaymentSetCardChoicePillDisabled($saved, true, pickMemberTitle);
        openPaymentSetCardChoicePillDisabled($new, true, pickMemberTitle);
        return;
    }

    openPaymentSetCardChoicePillDisabled($new, false);
    const savedDisabled = !savedPaymentsState.hasSavedCards;
    openPaymentSetCardChoicePillDisabled(
        $saved,
        savedDisabled,
        savedDisabled
            ? (opIsMemberSession() ? 'No saved cards on your account' : 'This member has no saved cards')
            : null
    );
}

export function setOpenPaymentHasSavedCards(hasSaved) {
    savedPaymentsState.hasSavedCards = !!hasSaved;
    syncOpenPaymentCardChoicePills();
}

export function openPaymentSetManualCcConstraints(opts) {
    const online = !!(opts && opts.online);
    const ptype = String((opts && opts.paymentType) || '');
    const isNew = online && ptype === 'new';

    if (!isNew) {
        ccEntrySyncManualCcState({
            idPrefix: 'open_payment',
            manualEnabled: false,
            requireBaseManualFields: false,
            requireZipAndCvv: false,
        });
        return;
    }

    setOpenPaymentDafCardType(getOpenPaymentDafCardType());
}

export function openPaymentEnableManualCc(enable) {
    const p = '#open_payment_';
    opModal().find(p + 'name,' + p + 'card,' + p + 'expiry_month,' + p + 'expiry_year,' + p + 'cvv2,' + p + 'avs_zip')
        .prop('disabled', !enable);
}

export function openPaymentClearCcSection() {
    const p = '#open_payment_';
    opModal().find(p + 'payment_type').val('');
    opModal().find('.payment_type_div').hide();
    opModal().find('.save_pay_div').hide();
    opModal().find('.open_pay_cc_manual').hide();
    opModal().find(p + 'name,' + p + 'card,' + p + 'expiry_month,' + p + 'expiry_year,' + p + 'cvv2,' + p + 'avs_zip')
        .val('')
        .prop('disabled', true);
    openPaymentSetManualCcConstraints({ online: false, paymentType: '' });
    clearOpenPaymentSavedCards();
    openPaymentSyncCardChoicePillActive(null);
    setOpenPaymentHasSavedCards(false);
    setOpenPaymentDafCardType('credit');
    openPaymentSyncPaymentUiState();
}

export function openPaymentPrepareOnlineCcShell() {
    opModal().find('.payment_type_div').show();
    opModal().find('.save_pay_div').hide();
    opModal().find('.open_pay_cc_manual').hide();
    opModal().find('#open_payment_payment_type').val('');
    openPaymentEnableManualCc(false);
    openPaymentSetManualCcConstraints({ online: true, paymentType: '' });
    openPaymentSyncCardChoicePillActive(null);
    openPaymentSyncPaymentUiState();
}

export function restoreOpenPaymentSavedCardsFromCache() {
    const uid = openPaymentSelectedUserId();
    if (!uid) {
        setOpenPaymentHasSavedCards(false);
        clearOpenPaymentSavedCards();
        return;
    }
    const cached = savedPaymentsState.cache[String(uid)];
    const cards = cached && cached.success ? (cached.saved_cards || []) : [];
    const hasSaved = cards.length > 0;
    setOpenPaymentHasSavedCards(hasSaved);
    if (!hasSaved) {
        clearOpenPaymentSavedCards();
        return;
    }
    setOpenPaymentSavedCards(cards);
}

export function activateOpenPaymentNewCardUi() {
    const p = '#open_payment_';
    openPaymentSyncCardChoicePillActive('new');
    opModal().find(p + 'payment_type').val('new');
    opModal().find('.open_pay_cc_manual').show();
    opModal().find('.save_pay_div').hide();
    clearOpenPaymentSavedCards();
    openPaymentEnableManualCc(true);
    setOpenPaymentDafCardType('credit');
    openPaymentSetManualCcConstraints({ online: true, paymentType: 'new' });
    openPaymentSyncPaymentUiState();
}

export function openPaymentSelectSoleCardChoiceIfNeeded() {
    if (!openPaymentIsOnline() || !openPaymentHasMemberSelected()) {
        return;
    }
    if (openPaymentCardChoiceValue()) {
        return;
    }
    if (!savedPaymentsState.hasSavedCards) {
        activateOpenPaymentNewCardUi();
    }
}

export function seedOpenPaymentSavedPaymentsFromConfig() {
    const cards = seedSavedPaymentsFromConfig();
    if (!cards) {
        return false;
    }
    setOpenPaymentHasSavedCards(true);
    setOpenPaymentSavedCards(cards);
    return true;
}

export function syncMemberOpenPaymentSavedCardsOnShow() {
    const muid = opMemberUserId() || openPaymentSelectedUserId();
    if (!muid) {
        return;
    }
    opModal().find('#open_payment_user_id').val(String(muid));
    openPaymentClearCcSection();
    openPaymentPrepareOnlineCcShell();
    seedOpenPaymentSavedPaymentsFromConfig();
    openPaymentSyncPaymentUiState();
    fetchOpenPaymentSavedPayments(muid).then(function (response) {
        const hasSaved = response.success && response.saved_cards && response.saved_cards.length > 0;
        setOpenPaymentHasSavedCards(hasSaved);
        if (!hasSaved) {
            activateOpenPaymentNewCardUi();
            return;
        }
        setOpenPaymentSavedCards(response.saved_cards);
        openPaymentSyncPaymentUiState();
    });
}

export function syncOpenPaymentForceSurchargeBanner() {
    const $banner = opModal().find('#open_payment_force_surcharge_banner');
    const $text = opModal().find('#open_payment_force_surcharge_banner_text');
    if (!$banner.length || !$text.length) {
        return;
    }
    const titles = opCfg().openPaymentForceSurchargeTitles || [];
    const pct = String(opCfg().coverSurchargePercentDisplay || '').trim();
    if (!titles.length || !pct || !opCfg().coverSurchargeOn || !openPaymentIsOnline()) {
        $banner.addClass('d-none');
        return;
    }
    const camp =
        titles.length === 1
            ? titles[0]
            : titles.slice(0, -1).join(', ') + ' and ' + titles[titles.length - 1];
    $text.text(
        'A ' +
            pct +
            '% processing fee will be added to pledges paid by card for ' +
            camp +
            '. Use the checkbox below if you would like to cover processing costs on this credit purchase.'
    );
    $banner.removeClass('d-none');
}

export function toggleOpenPaymentLayout() {
    const online = openPaymentIsOnline();
    const $modal = opModal();
    const $descriptionLabel = opModal().find('#open_payment_description_label');

    if (online) {
        $modal.removeClass('open-payment-layout--cash').addClass('open-payment-layout--card');
        $descriptionLabel.text('Notes');
        opModal().find('#open_payment_submit').text('Pay');
        openPaymentPrepareOnlineCcShell();
        restoreOpenPaymentSavedCardsFromCache();
        openPaymentSelectSoleCardChoiceIfNeeded();
    } else {
        $modal.removeClass('open-payment-layout--card').addClass('open-payment-layout--cash');
        $descriptionLabel.text('Notes / Check #');
        openPaymentClearCcSection();
        opModal().find('#open_payment_submit').text('Save');
    }

    openPaymentSetManualCcConstraints({ online: online, paymentType: openPaymentCardChoiceValue() });
    openPaymentSyncMethodPills();
    openPaymentSyncPaymentUiState();
    syncOpenPaymentForceSurchargeBanner();
}

export function openPaymentSyncPaymentUiState() {
    const online = openPaymentIsOnline();
    const hasMember = openPaymentHasMemberSelected();

    syncOpenPaymentCardChoicePills();

    if (!hasMember) {
        clearOpenPaymentSavedCards();
        opModal().find('#open_payment_payment_type').val('');
        openPaymentSyncCardChoicePillActive(null);
        openPaymentEnableManualCc(false);
        opModal().find('.save_pay_div').hide();
        opModal().find('.open_pay_cc_manual').hide();
    }

    const cardChoiceMade = openPaymentCardChoiceValue() === 'new' || openPaymentCardChoiceValue() === 'saved';
    const mustChooseCard = online && !cardChoiceMade;
    opModal().find('#open_payment_submit').prop('disabled', mustChooseCard || isOpenPaymentSubmitLocked());
}

let openPaymentSubmitLocked = false;

export function isOpenPaymentSubmitLocked() {
    return openPaymentSubmitLocked;
}

export function tryLockOpenPaymentSubmit() {
    if (openPaymentSubmitLocked) {
        return false;
    }
    openPaymentSubmitLocked = true;
    opModal().find('#open_payment_submit').prop('disabled', true);
    return true;
}

export function unlockOpenPaymentSubmit() {
    openPaymentSubmitLocked = false;
    if (!opModal().length) {
        return;
    }
    openPaymentSyncPaymentUiState();
}

export function closeOpenPaymentModal(opts) {
    unlockOpenPaymentSubmit();
    const action = (opts && typeof opts === 'object' && opts.action) ? String(opts.action) : 'cancel';
    const $form = opModal().find('#validOpenPayment');
    if ($form.length && $form[0]) {
        $form[0].reset();
    }
    const muid = opMemberUserId();
    if (muid) {
        opModal().find('#open_payment_user_id').val(String(muid));
    } else {
        opModal().find('#open_payment_user_id').val(null).trigger('change');
    }
    opModal().find('#open_payment_payment_type').val('');
    openPaymentClearCcSection();
    hideOpenPaymentAjaxMsg();
    if (!opIsMemberSession()) {
        opModal().find('#open_pay_online').prop('checked', true);
        opModal().find('#open_pay_offline').prop('checked', false);
        openPaymentSyncMethodPills();
    }
    toggleOpenPaymentLayout();

    const formatted = formatPaymentDate();
    opModal().find('#open_payment_date').val(formatted);
    const $dpClose = opModal().find('#open_payment_datepicker');
    if ($dpClose.length && $dpClose.data('datepicker')) {
        $dpClose.datepicker('setDate', formatted);
    }

    const $modal = opModal();
    const modalInstance = $modal.data('bs.modal');
    if (modalInstance) {
        modalInstance._isTransitioning = false;
    }
    $modal.modal('hide');

    if (action !== 'submit') {
        return;
    }

    const after = resolveOpenCreditAfterClose();
    const uid = opMemberUserId() || String(opModal().find('#open_payment_user_id').val() || '');
    runAfterCloseAction(after, uid);
}
